<div class="main-wrapper">
  <div class="header-wrapper">
    <div *ngIf="headerMenushowHide">
      <app-header-search-bar></app-header-search-bar>
    </div>
    <router-outlet>
    </router-outlet>
  </div>
</div>